import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';
import { getBoardIdFromUrl } from './utils';

export const Miro = ({
  url,
  isScreenshotMode,
  embedAutoPlay = true,
}: {
  url: string;
  isScreenshotMode?: boolean;
  embedAutoPlay?: boolean;
}) => {
  const t = useTranslations('presenting');
  const id = React.useMemo(() => {
    return getBoardIdFromUrl(url);
  }, [url]);

  return (
    <Box
      flex="1 1 auto"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      bg="neutralWeakest"
      borderRadius={2}
    >
      {isScreenshotMode ? (
        <Text fontSize={4}>{t('miro_slide_screenshot_mode_message')}</Text>
      ) : id ? (
        <iframe
          width="100%"
          height="100%"
          src={`https://miro.com/app/live-embed/${id}?embedAutoplay=${embedAutoPlay}`}
          frameBorder="0"
          scrolling="no"
          data-testid="miro-embed"
        />
      ) : (
        <Text fontSize={2}>{t('miro_slide_invalid_url_message')}</Text>
      )}
    </Box>
  );
};
